import React from "react";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import classes from "./ResponsiveTableBody.module.scss";
import { useTranslation } from "react-i18next";

export default function ResponsiveTableBody({
  tableKeys,
  tableValues,
  row,
  actions,
}) {
  const borderStyle = { borderBottom: "5px solid #D1DBE8" };
  const { i18n } = useTranslation();

  return (
    <>
      {tableKeys.map((item, inx) => (
        <TableRow
          key={inx}
          style={inx === tableKeys?.length - 1 ? borderStyle : {}}
          className={classes.root}
        >
          <TableCell
            className={
              i18n.language === "en"
                ? classes.tableCellLeftAlign
                : classes.tableCellRightAlign
            }
            style={{ fontWeight: "bold" }}
          >
            {item}
          </TableCell>
          <TableCell
            className={
              i18n.language === "en"
                ? classes.tableCellLeftAlign
                : classes.tableCellRightAlign
            }
            component="th"
            scope="row"
          >
            {inx === tableKeys.length - 1 ? actions : row[tableValues[inx]]}
          </TableCell>
        </TableRow>
      ))}
    </>
  );
}
